// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2pqDa","header":"ReportDetails_header__1oKQV","title":"ReportDetails_title__1KK7v","left":"ReportDetails_left__1u4hf"};